import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { NotAuthorizedComponent } from './shared/components/not-authorized/not-authorized.component';
import { NotAuthorizedRedirectGuard } from './shared/components/not-authorized/not-authorized-redirect.guard';

const hostRoutes: Routes = [
  {
    // Every route nested here requires sign-in: canMatch on this wrapper runs before any
    // child route (including its lazy chunk) is matched, so one guard covers them all.
    path: '',
    canMatch: [xpoAuthCanMatch()],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: AppRoutes.TARIFF_LIST,
      },
      {
        path: AppRoutes.TARIFF_LIST,
        loadChildren: () => import('./tariff-list/tariff-list.module').then((m) => m.TariffListModule),
      },
      {
        path: AppRoutes.TARIFF_DETAIL,
        loadChildren: () => import('./tariff-detail/tariff-detail.module').then((m) => m.TariffDetailModule),
      },
      {
        path: AppRoutes.TRANSIT_TIME_FILE_REQUEST,
        loadChildren: () => import('./transit-time-file/transit-time-file.module').then((m) => m.TransitTimeFileModule),
      },
      {
        path: AppRoutes.RATE_FILE_REQUEST,
        loadChildren: () => import('./rate-file/rate-file.module').then((m) => m.RateFileModule),
      },
      {
        path: AppRoutes.BID_FILE_REQUEST,
        loadChildren: () => import('./bid-file-request/bid-file-request.module').then((m) => m.BidFileRequestModule),
      },
    ],
  },
  // Outside the guarded subtree on purpose: this must stay reachable without being signed in.
  {
    path: AppRoutes.NOT_AUTHORIZED_PAGE,
    component: NotAuthorizedComponent,
    canActivate: [NotAuthorizedRedirectGuard],
  },
  {
    path: '**',
    redirectTo: AppRoutes.TARIFF_LIST,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(hostRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
